import moment from 'moment';
import { Button } from '../common/Button';
import reminderImg from '../../styles/reminder.png'
import { TagInput } from '../common/TagInput';
import React from 'react';
import { Tag } from 'react-tag-autocomplete';

// @ts-ignore
export default (onClickHandler, activeIndex, onTagClickHandler, suggestions: Tag[] | []) => {
    return [
        {
            name: 'Reminder',
            // @ts-ignore
            cell: (row, index, column, id) => {
                return <Button type="button" className="image" onClick={() => {
                    onClickHandler(row)
                }}><img src={reminderImg}/></Button>
            }
        },
        {
            name: 'Date invited',
            id: 'assessmentInviteDate',
            // @ts-ignore
            selector: row => row.assessmentInviteDate,
            // @ts-ignore
            format: row => {
                const date = moment(row.assessmentInviteDate);
                const formattedDate = date.format('YYYY-MM-DD HH:mm')
                const dateTimeSplit = formattedDate.split(' ')
                const parts = dateTimeSplit[0].split('-')
                const daysSinceInvite = moment().diff(date, 'days')
                const daysAgoString = daysSinceInvite > 0
                    ? daysSinceInvite === 1
                        ? `${daysSinceInvite} day ago`
                        : `${daysSinceInvite} days ago`
                    : 'today';
                return `${parts[2]}-${parts[1]}-${parts[0]} ${dateTimeSplit[1]} (${daysAgoString})` ;
            },
            sortable: true
        },
        {
            name: 'Institute',
            id: 'companyParentName',
            // @ts-ignore
            selector: row => {

                return row.companyParentName.charAt(0).toUpperCase() + row.companyParentName.slice(1);
            },
            sortable: true
        },
        {
            name: 'Company',
            id: 'companyName',
            // @ts-ignore
            selector: row => {
                if(!row.companyName) return row.companyName
                return row.companyName.charAt(0).toUpperCase() + row.companyName.slice(1);
            },
            sortable: true
        },
        {
            name: 'Label',
            id: 'label',
            // @ts-ignore
            selector: row => {
                // @ts-ignore
                return row.tags.map(tag => tag.name.toLowerCase()).join('')
            },
            // @ts-ignore
            format: row => {
                // @ts-ignore
                return row.tags.map(tag => tag.name).join(', ')
            },
            sortable: true,
            // @ts-ignore
            cell: (row, index) => {
                return <TagInput
                    rowIndex={index}
                    currentActiveRowIndex={activeIndex}
                    setCurrentActiveRowIndex={onTagClickHandler}
                    suggestions={suggestions}
                    entityId={row.id}
                    type={'ASSESSMENT_INVITE'}
                    row={row}
                />
            }
        },
        {
            name: 'Founder',
            id: 'founder',
            // @ts-ignore
            selector: row => row.founder,
            // @ts-ignore
            format: row => {
                return row.founder ? row.founder : '-'
            },
            sortable: true
        },
        {
            name: 'Email',
            id: 'emailAddressFounder',
            // @ts-ignore
            selector: row => row.emailAddressFounder,
            // @ts-ignore
            format: row => {
                return row.emailAddressFounder ? row.emailAddressFounder : '-'
            },
            sortable: true
        },
        {
            name: 'Status',
            id: 'assessmentStatus',
            // @ts-ignore
            selector: row => row.assessmentStatus,
            // @ts-ignore
            format: row => {
                return row.assessmentStatus !== undefined ? row.assessmentStatus : 'INVITED'
            },
            sortable: true
        },
        {
            name: 'Sent by',
            id: 'invitee',
            // @ts-ignore
            selector: row => row.invitee,
            // @ts-ignore
            format: row => {
                return row.invitee !== null ? row.invitee : '-'
            },
            sortable: true
        },
        {
            name: 'Scan',
            id: 'assessmentType',
            // @ts-ignore
            selector: row => row.assessmentType,
            // @ts-ignore
            format: row => {
                return row.assessmentType !== null ? row.assessmentType : '-'
            },
            sortable: true
        },
        {
            name: 'Last reminder',
            id: 'lastReminderSent',
            // @ts-ignore
            selector: row => row.lastReminderSent,
            // @ts-ignore
            format: row => {
                if(!row.lastReminderSent) {
                    return '-'
                }
                const date = moment(row.lastReminderSent);
                const formattedDate = date.format('YYYY-MM-DD HH:mm')
                const dateTimeSplit = formattedDate.split(' ')
                const parts = dateTimeSplit[0].split('-')
                const daysSinceInvite = moment().diff(date, 'days')
                const daysAgoString = daysSinceInvite > 0
                    ? daysSinceInvite === 1
                        ? `${daysSinceInvite} day ago`
                        : `${daysSinceInvite} days ago`
                    : 'today';

                return daysAgoString
            },
            sortable: true
        },
    ];
}
